import "./styles.css";
import { Box, Grid, Container } from "@mui/material";
import { useState } from "react";
import OtpVerification from "./otpVerification";
import Login from "./login";

const App = () => {
  const [qrCodeSrc, setQrCodeSrc] = useState<string | null>(null);

  return (
    <Container className="loginContainer">
      <Grid>
        <Box className="LoginPageLogo"></Box>
        <Box>
          {qrCodeSrc ? (
            <OtpVerification qrCodeSrc={qrCodeSrc} />
          ) : (
            <Login setQrCodeSrc={setQrCodeSrc} />
          )}
        </Box>
      </Grid>
    </Container>
  );
};

export default App;
